import React, { useState } from "react";
import { BinanceIcon, Close } from "../../../icon/IconTheme";

const OwnerShowCaseContent = ({ modalOpen, setModalOpen }) => {
	const [value, setValue] = useState("3.00");
	return (
		<>
			<div className={`__modal ${modalOpen ? "active" : ""}`}>
				<div
					className="__modal-overlay"
					onClick={() => setModalOpen(false)}
				></div>
				<div className="__modal-dialog __modal-dialog-sm">
					<div className="__modal-body">
						<div className="__modal-title">
							<h4 className="title">Hashima 3</h4>
							<div
								className="__modal-close"
								onClick={() => setModalOpen(false)}
							>
								<Close />
							</div>
						</div>
						<h3 className="enter-price-title">Enter the new price</h3>
						<form>
							<div className="price-input-group input-group">
								<input
									type="number"
									className="form-control form--control"
									placeholder="Enter Price"
									value={value}
									onChange={(e) => setValue(e.target.value)}
								/>
								<div className="d-flex align-items-center group-txt">
									<BinanceIcon /> <span>BNB</span>
								</div>
							</div>
							<button type="submit" className="btn cmn-btn w-100">
								Update
							</button>
							<div
								className="text-center mt-3 cancel-modal"
								onClick={() => setModalOpen(false)}
							>
								Cancel
							</div>
						</form>
					</div>
				</div>
			</div>
		</>
	);
};

export default OwnerShowCaseContent;
